import clsx from 'clsx';
import styles from './CheckboxAndData.module.css';

export default function CheckboxAndData({
  className,
  label,
  checked = false,
  disabled = false,
  onChange,
  checkboxSize = 16,
  labelSize = 16,
  labelColor,
  ...props
}) {
  return (
    <label
      className={clsx(
        styles.CheckboxAndData,
        className,
        disabled && styles.disabled
      )}
      style={{
        color: labelColor,
        cursor: disabled ? 'not-allowed' : 'pointer',
      }}
      {...props}
    >
      <input
        type="checkbox"
        className={styles.checkbox}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        style={{
          width: checkboxSize,
          height: checkboxSize,
          cursor: disabled ? 'not-allowed' : 'pointer',
        }}
      />
      <span className={styles.label} style={{ fontSize: labelSize }}>
        {label}
      </span>
    </label>
  );
}
